let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("76n7a"), load("l253H"), load("cBAfA")]).then(() => parcelRequire('fsLhR'));